<template>
	<client-only>
		<button
			:class="[
				`flex items-center z-10  bg-white bg-opacity-50 rounded-${rounded} w-${wrapperSize} h-${wrapperSize} ${
					absolute && 'absolute'
				} justify-center right-6 top-2 ${
					border && `border-${border.weight}  border-${border.color}`
				} cursor-pointer hover:bg-gray  hover:bg-opacity-50`
			]"
			name="Add to wishlist"
			aria-label="add to wishlist"
			@click="
				(e) => {
					e.preventDefault();
					addToWishlist(productIdValue);
				}
			"
		>
			<HeartIconSolid
				v-if="wishlistItems.includes(productIdValue)"
				class="h-6 w-6 text-primary"
			/>
			<HeartIconOutline v-else class="h-6 w-6 text-primary" />
		</button>
	</client-only>
</template>

<script setup lang="ts">
import { HeartIcon as HeartIconSolid } from "@heroicons/vue/24/solid";
import { HeartIcon as HeartIconOutline } from "@heroicons/vue/24/outline";
import { storeToRefs } from "pinia";
import { useGtmEvents } from "~/composables/useGtmEvents";
import type {
	Product,
	ProductItem
} from "@nwt/norce-pwa/dist/runtime/types/api/product/product";
import type { FilteredProductItem } from "@nwt/norce-pwa/dist/runtime/types/api/searchAndFilter/filters";

interface Props {
	wrapperSize: string | number;
	rounded: string;
	absolute?: boolean;
	border?: { color: string; weight: number };
	product: Product | Partial<FilteredProductItem> | ProductItem;
	variantParametricsNumber?: number;
}

const { $toast } = useNuxtApp();

const {
	wrapperSize,
	rounded,
	absolute,
	border,
	variantParametricsNumber,
	product
} = defineProps<Props>();
const { updateWishList } = useWishlistStore();
const { wishlistItems } = storeToRefs(useWishlistStore());
const { addToWishlist: addToWishlistGtm } = useGtmEvents();

const { selectedColor, selectedSecondParametric } =
	storeToRefs(useProductStore());

const { $i18n } = useNuxtApp();

const productIdValue = computed(() => product.Id);

const addToWishlist = (productId: number) => {
	if (!variantParametricsNumber) {
		if (!wishlistItems.value?.includes(productId)) {
			addToWishlistGtm(product);
		}

		updateWishList(productId);

		return $toast.success($i18n.t("Wishlist updated"));
	}

	const allProductParametricsSelected =
		variantParametricsNumber === 1
			? selectedColor.value || selectedSecondParametric.value
			: selectedColor.value && selectedSecondParametric.value;

	if (allProductParametricsSelected) {
		if (!wishlistItems.value?.includes(productId)) {
			addToWishlistGtm(product);
		}

		updateWishList(productId);

		return $toast.success($i18n.t("Wishlist updated"));
	} else {
		return $toast.error(
			`You need to select ${variantParametricsNumber} product attributes`
		);
	}
};
</script>
